import React from 'react';
import BrandLogo from './BrandLogo';

const HIGHLIGHTS = [
  {
    icon: 'bi-clock-history',
    title: 'About 10 minutes',
    body: 'Your progress saves automatically as you move between steps.',
  },
  {
    icon: 'bi-people',
    title: 'Beneficiary details',
    body: "You'll need names, dates of birth and addresses for your beneficiaries.",
  },
  {
    icon: 'bi-shield-lock',
    title: 'No SSNs online',
    body: "We'll collect Social Security Numbers at your Getting Started meeting instead.",
  },
];

/**
 * Welcome screen shown before the client starts the Personal Data Sheet.
 */
export default function StepWelcome({ clientName }) {
  return (
    <div className="cashflow-welcome text-center py-4">
      <BrandLogo size={72} className="mb-3" />
      <h2 className="h3 fw-bold mb-2">
        Welcome{clientName ? `, ${clientName.split(' ')[0]}` : ''}!
      </h2>
      <p className="text-muted mb-2" style={{ maxWidth: 620, margin: '0 auto' }}>
        To set up your client profile and establish your investment management
        accounts as efficiently as possible, we need the following information
        filled out completely.
      </p>
      <p className="text-muted mb-4" style={{ maxWidth: 620, margin: '0 auto' }}>
        This form is secure, but to further protect your personal information
        we will not ask for your Social Security Numbers digitally. We will ask
        for those during your Getting Started meeting so we can pre-fill your
        account applications.
      </p>

      <div className="row g-3 justify-content-center" style={{ maxWidth: 780, margin: '0 auto' }}>
        {HIGHLIGHTS.map(({ icon, title, body }) => (
          <div className="col-md-4" key={title}>
            <div className="card h-100 shadow-sm border-0">
              <div className="card-body">
                <i className={`bi ${icon} fs-3 text-danger mb-2`} />
                <h6 className="fw-semibold">{title}</h6>
                <p className="small text-muted mb-0">{body}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
